// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatSourceSweep-modulesweep__zyTgb";
var _2 = "GretaAIChatSourceSweep-moduletoCrm__shPGN";
export { _1 as "sweep", _2 as "toCrm" }
